import { bool, string } from "prop-types";

import { SITE_TITLE } from "../../constants";

import { Helmet } from "react-helmet";

const Meta = props => {
  const { canonical, description, noIndex, title } = props;

  return (
    <Helmet defaultTitle={SITE_TITLE} defer={false}>
      <title>{title}</title>
      {!!description && <meta name="description" content={description} />}
      {!!noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!!canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

Meta.propTypes = {
  canonical: string,
  /**
   * Custom prop type validator to make sure
   * meta description is not too short or too long
   **/
  description: (props, propName, componentName) => {
    if (!!props[propName]) {
      if (typeof props[propName] !== "string") {
        throw new Error(
          `${propName} supplied to ${componentName} is not a string.`
        );
      } else if (props[propName].length < 50) {
        throw new Error(
          `${propName} supplied to ${componentName} is less than 50 characters.`
        );
      }
    }
  },
  noIndex: bool,
  title: string,
};

export default Meta;
